const previewModal = {
    header: 'Podgląd',
    cancel: 'WRÓĆ',
    preview: 'Podlgąd',
    tooltip: 'Zapisz zmiany, aby podejrzeć zmienione zdjęcie i tekst',
};

export default previewModal;